import React from 'react'
import { Zap } from 'lucide-react'

export function EarnedPoints({ value }) {
  return <span className="text-xs font-semibold text-[var(--color-pick-correct-text)]">+{value}</span>
}

export function PendingPoints({ value }) {
  return (
    <div className="flex items-center gap-1">
      <Zap className="h-3.5 w-3.5 text-[var(--orange-9)]" />
      <span className="text-xs font-semibold text-[var(--mauve-9)]">+{value}</span>
    </div>
  )
}
